import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import CustomizedCurioso from './CustomizedCurioso';
import { parseDecodedCurioso, decodeCurioso } from '../lib/utilityFunctions';
import { PALETTES } from '../data/constants';

const onShareClicked = (encodedCurioso) => {
  console.log(window.location.origin)
  const shareableLink = window.location.origin === 'http://localhost:3000' 
    ? 'https://www.google.com'
    : `${window.location.origin}/curioso-quiz/#/./share/${encodedCurioso}`;
  console.log(shareableLink);
  window.FB.ui({
    method: 'share',
    quote: `I just took Amplify's Curioso personality-quiz. Here's what my curioso looks like!`,
    href: shareableLink
  }, function(response){});
}

class CuriosoReveal extends Component {
  constructor(props) {
    super(props);
    const decodedCurioso = decodeCurioso(props.match.params.encodedCurioso);
    const { descriptionStrings} = parseDecodedCurioso(decodedCurioso);
    this.descriptionStrings = descriptionStrings;
  }

  componentDidMount() {
    const { dark, light } = PALETTES[2];

    const backgrounds = document.getElementsByClassName("QuestionBackground");
    for(let i = 0; i < backgrounds.length; i++) {
      backgrounds[i].style.setProperty('--light-color', light);
      backgrounds[i].style.setProperty('--dark-color', dark);
    }
  }

  render() {
    const {props} = this;
    return (<div className='Container QuestionBackground'>
      <div id='burst'></div> 
        <div id="result">
          <div id='endparagraph'>
            <p className="bubble" id='p1'>{this.descriptionStrings[1]}</p>
            <p className="bubble" id='p2'>{this.descriptionStrings[2]}</p>
            <p className="bubble" id='p3'>{this.descriptionStrings[0]}</p>
          </div>
          <div id="curioso"><CustomizedCurioso encodedCurioso={props.match.params.encodedCurioso} /></div>
        </div>
        <div id='btn'>
          <p>It's time to show off your skills!</p>
          <button className='endbtn' id='share' onClick={() => onShareClicked(props.match.params.encodedCurioso)}>share</button>
          <Link className='endbtn' to="/">
             ⟲ 
          </Link>          
        </div>
  </div>)
  };
}

export default CuriosoReveal;